import { getItem } from '@/utils/storage'

let candidatesViewMode = getItem('candidatesMode');
export const state = {
  candidatesMode: candidatesViewMode?candidatesViewMode:1,
}
